App.directive('showHint', ['$window', function($window) {
    return {
        link: link,
        restrict: 'A'
    };

    function link(scope, elem, attrs) {
        elem.on('mouseenter', function() {
            elem.find('.hint-box').velocity("stop", true).velocity("fadeIn", {duration: 500});
        });
        elem.on('mouseleave', function() {
            elem.find('.hint-box').velocity("stop", true).velocity("fadeOut", {duration: 500});
        });
    };
}]);